import gsap from 'gsap'
import store from './store'

export default class Loader {
  constructor() {
    this.getElems()
  }

  getElems() {
    store.panel = document.querySelector('.panel')
  }

  play() {
    return new Promise((resolve) => {
      if (store.detect.isMobile) {
        window.dispatchEvent(new CustomEvent('loaderComplete'))
        store.isFirstLoaded = true;
        gsap.set(store.panel, {opacity: 0});
        resolve();
      } else {
        const tl = gsap.timeline({
          onComplete: () => {
            store.menu && !store.detect.isMobile && store.menu.init()

            window.dispatchEvent(new CustomEvent('loaderComplete'))
            store.isFirstLoaded = true
            resolve()
          }
        })

        // eslint-disable-next-line prefer-reflect
        tl
          .to(store.panel, {
            opacity: 0,
            duration: 0.8,
            ease: 'power3.out'
          })
      }
    })
  }
}
